import { getCookie } from './shared/cookies';

export function initJobModal() {
  // 一度閉じるボタンを押下したかどうか
  let isClose = false;

  // モーダル要素を取得
  const popup = document.querySelector('.js-job-modal');

  // モーダルの閉じるボタン要素を取得
  const popupClose = document.querySelector('.js-job-modal__close');

  // モーダルを表示するID要素を取得
  const target = document.querySelector('#job_working_time');

  if (!popup || !target) return;

  // モーダル内のお気に入りボタン要素を取得
  const favoriteButton = popup.querySelector(
    '.ga4-click-event-popup-favorite-button'
  );

  // お気に入りボタンが「お気に入り済み」かどうか
  const isFavorite =
    favoriteButton && favoriteButton.classList.contains('-done');

  // この求人を見たことがあるかどうか
  const isViewedJob = getCookie('is_viewed_job');

  // スクロールでモーダルを表示するときの処理
  window.addEventListener('scroll', () => {
    if (!popup || !target || isClose) return;
    if (isFavorite) return; // お気に入りに入っている場合は表示しない
    if (!isViewedJob) return; // 初回の場合は表示しない

    const targetPosition = target.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;

    // スクロールが表示位置超えればクラスを追加
    if (targetPosition < windowHeight) {
      popup.classList.add('-active');
    }
  });

  // モーダルの閉じるボタンがクリックされたときの処理
  if (popupClose) {
    popupClose.addEventListener('click', () => {
      popup.classList.remove('-active');
      isClose = true;
    });
  }
}
